import styled, { css } from 'styled-components';
import theme from '../../../../../theme';

const Container = styled.div<{
    $valid: boolean;
}>`
    display: flex;
    align-items: center;

    small {
        font-size: 12px;
        font-weight: 400;
        margin-left: 10px;
        
        ${props => props.$valid ? css`
            color: ${theme.successColor} !important;
        ` : css`
            color: ${theme.errorColor} !important;
        `};
    }
`;

export { Container };